import { toast } from "sonner";

export async function shareGuide(url, name) {
  const data = { title: name || "Guida ospiti", text: `Ecco la guida della struttura ${name || ""}`.trim(), url };
  if (navigator.share) {
    try { await navigator.share(data); return; } catch { /* user cancelled */ return; }
  }
  try { await navigator.clipboard.writeText(url); toast.success("Link copiato negli appunti"); }
  catch { toast.info(url); }
}
